import React, { useState, useEffect } from "react";

const ProductModal = ({ isOpen, onClose, product = null, onSave }) => {
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    category: "",
    price: "",
    stock: "",
    image: null,
  });

  // Si product cambia (editar), cargar los datos en el formulario
  useEffect(() => {
    if (product) {
      setFormData({
        name: product.name || "",
        description: product.description || "",
        category: product.category || "",
        price: product.price || "",
        stock: product.stock || "",
        image: product.image || null,
      });
    } else {
      setFormData({
        name: "",
        description: "",
        category: "",
        price: "",
        stock: "",
        image: null,
      });
    }
  }, [product]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { id, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [id]: files[0] });
    } else {
      setFormData({ ...formData, [id]: value });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
    onClose();
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
      <div className="bg-gray-900 rounded-lg max-w-2xl w-full p-6 overflow-y-auto max-h-[90vh]">
        <h2 className="text-white text-2xl font-bold mb-2">
          {product ? "Editar Producto" : "Agregar Producto"}
        </h2>
        <p className="text-gray-400 mb-6">
          Completa el formulario para {product ? "editar" : "agregar"} un producto.
        </p>
        <form className="space-y-6" onSubmit={handleSubmit}>
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2">
              Nombre del Producto
            </label>
            <input
              id="name"
              type="text"
              value={formData.name}
              onChange={handleChange}
              placeholder="Ej: Camiseta de algodón"
              className="form-input block w-full rounded-md border-gray-700 bg-gray-800 text-white shadow-sm focus:border-[#1173d4] focus:ring focus:ring-[#1173d4] focus:ring-opacity-50 placeholder:text-gray-500"
            />
          </div>

          <div>
            <label htmlFor="description" className="block text-sm font-medium text-gray-300 mb-2">
              Descripción
            </label>
            <textarea
              id="description"
              value={formData.description}
              onChange={handleChange}
              placeholder="Describe las características principales del producto"
              className="form-textarea block w-full rounded-md border-gray-700 bg-gray-800 text-white shadow-sm focus:border-[#1173d4] focus:ring focus:ring-[#1173d4] focus:ring-opacity-50 min-h-32 placeholder:text-gray-500"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label htmlFor="category" className="block text-sm font-medium text-gray-300 mb-2">
                Categoría
              </label>
              <select
                id="category"
                value={formData.category}
                onChange={handleChange}
                className="form-select block w-full rounded-md border-gray-700 bg-gray-800 text-white shadow-sm focus:border-[#1173d4] focus:ring focus:ring-[#1173d4] focus:ring-opacity-50"
              >
                <option value="">Seleccionar categoría</option>
                <option>Ropa</option>
                <option>Accesorios</option>
                <option>Calzado</option>
              </select>
            </div>
            <div>
              <label htmlFor="price" className="block text-sm font-medium text-gray-300 mb-2">
                Precio
              </label>
              <div className="relative">
                <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3 text-gray-400">$</span>
                <input
                  id="price"
                  type="text"
                  value={formData.price}
                  onChange={handleChange}
                  placeholder="0.00"
                  className="form-input pl-7 block w-full rounded-md border-gray-700 bg-gray-800 text-white shadow-sm focus:border-[#1173d4] focus:ring focus:ring-[#1173d4] focus:ring-opacity-50 placeholder:text-gray-500"
                />
              </div>
            </div>
          </div>

          <div>
            <label htmlFor="stock" className="block text-sm font-medium text-gray-300 mb-2">
              Stock
            </label>
            <input
              id="stock"
              type="number"
              value={formData.stock}
              onChange={handleChange}
              placeholder="Cantidad disponible"
              className="form-input block w-full rounded-md border-gray-700 bg-gray-800 text-white shadow-sm focus:border-[#1173d4] focus:ring focus:ring-[#1173d4] focus:ring-opacity-50 placeholder:text-gray-500"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-300 mb-2">
              Imagen del Producto
            </label>
            <div className="mt-2 flex justify-center rounded-md border-2 border-dashed border-gray-700 px-6 pt-5 pb-6">
              <div className="space-y-1 text-center">
                <span className="material-symbols-outlined text-5xl text-gray-500">image</span>
                <div className="flex text-sm text-gray-400">
                  <label
                    htmlFor="image"
                    className="relative cursor-pointer rounded-md font-medium text-[#1173d4] hover:text-blue-400"
                  >
                    <span>Sube un archivo</span>
                    <input id="image" name="image" type="file" className="sr-only" onChange={handleChange} />
                  </label>
                  <p className="pl-1">o arrástralo y suéltalo</p>
                </div>
                <p className="text-xs text-gray-500">PNG, JPG, GIF hasta 10MB</p>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-4 pt-4">
            <button
              type="button"
              onClick={onClose}
              className="rounded-md border border-gray-600 bg-gray-700 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-gray-600"
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="rounded-md border border-transparent bg-[#1173d4] px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-blue-600"
            >
              Guardar Producto
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProductModal;
